//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    added: {
      type: Boolean,
      required: true,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    species: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    formData: {},
    savedData: {},
    open: false,
  }),
  computed: {
    isFilled() {
      return (this.formData && this.formData.abundance && this.formData.certainty);
    },
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        if (JSON.stringify(this.formData) !== JSON.stringify(this.savedData)) {
          this.$emit('setData', this.index, this.formData);
          this.savedData = JSON.parse(JSON.stringify(this.species.reportSpecies));
        }
      },
    },
  },
  mounted() {
    if (this.species.reportSpecies) {
      this.formData = JSON.parse(JSON.stringify(this.species.reportSpecies));
      this.savedData = JSON.parse(JSON.stringify(this.species.reportSpecies));
    }
  },
  methods: {
    closeBlock() {
      this.open = false;
    },
    openBlock() {
      if (this.editable) {
        this.$emit('onOpen');
        this.open = !this.open;
      }
    },
  },
};
